import React, { FC } from 'react';
import classNames from 'classnames/bind';
import { AgendaData } from 'sections/Events/components/AgendaProgram/AgendaProgram.types';
import styles from 'sections/Events/components/AgendaProgram/AgendaProgram.module.scss';

const cn = classNames.bind(styles);

interface AgendaProgramProps {
  agendaData: AgendaData[],
  title: string,
  border: boolean,
}

const AgendaProgram: FC<AgendaProgramProps> = ({ agendaData, title, border}): React.ReactElement => {
    return (
        <div className={cn('agenda-program__table')}>
            <div className={cn('agenda-program__table-title-box', { 'border': !border })}>
                <p className={cn('agenda-program__table-title')}>{title}</p>
            </div>
            <div className={cn('agenda-program__table-content')}>
                <div className={cn('agenda-program__table-content-row')}>
                    <div className={cn('agenda-program__table-content-cell', 'agenda-program__table-content-cell-first', 'name')}>
                        <p className={cn('agenda-program__table-content-text', 'bold')}>Time</p>
                    </div>
                    <div className={cn('agenda-program__table-content-cell', 'agenda-program__table-content-cell-second', 'name')}>
                        <p className={cn('agenda-program__table-content-text', 'bold')}>Program</p>
                    </div>
                </div>
                {agendaData.map((item, index) => {
                    const time = item.time;

                    const cellContent = item.content.map((item, index) => {
                        if (item.bold) {
                            if (item.inline) {
                                return <p key={index} className={cn('agenda-program__table-content-text', 'bold')} style={{display: "inline"}}>{item.text}</p>;
                            } else {
                                return <p key={index} className={cn('agenda-program__table-content-text', 'bold')}>{item.text}</p>;
                            }
                        } else {
                            if (item.inline) {
                                return <p key={index} className={cn('agenda-program__table-content-text')} style={{display: "inline"}}>{item.text}</p>;
                            } else {
                                return <p key={index} className={cn('agenda-program__table-content-text')}>{item.text}</p>;
                            }
                        }
                    });

                    return (
                        <div key={`${index}_${item.time}`} className={cn('agenda-program__table-content-row')}>
                            <div className={cn(
                              'agenda-program__table-content-cell', 
                              'agenda-program__table-content-cell-first', {
                                  'border': border && (index === agendaData.length - 1) 
                                }
                              )}
                            >
                                <p className={cn('agenda-program__table-content-text')}>{time}</p>
                            </div>
                            <div className={cn(
                              'agenda-program__table-content-cell', 
                              'agenda-program__table-content-cell-second', { 
                                  'border': border && (index === agendaData.length - 1)
                                }
                              )}
                            >
                                {cellContent}
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export { AgendaProgram };
